import { createSlice } from '@reduxjs/toolkit';
import actions from './actions';
import { NAME_REDUCER } from './constants';
import { IState } from '../interfaces/reducer';

const initialState: IState = {
  dataDemo: [],
  dataChannels: null,
  dataLayouts: null,
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(actions.getDemoData.success, (state, { payload }) => {
        state.dataDemo = payload;
      })
      .addCase(actions.getListChannels.success, (state, { payload }) => {
        const { list, total, from } = payload;

        const current = state.dataChannels;

        const newList = from !== 1 && current ? [...current.content, ...list] : list;

        state.dataChannels = {
          ...current,
          content: newList,
          totalElements: total,
          from,
          hasMore: newList.length < total,
          loading: false,
        };
      })
      .addCase(actions.getListLayouts.success, (state, { payload }) => {
        state.dataLayouts = payload;
      })
      .addCase(actions.deleteChannel.success, (state, { payload }) => {
        const current = state.dataChannels;
        if (current) {
          const newList = current.content.filter(item => item.id !== payload);
          state.dataChannels = {
            ...current,
            content: newList,
            totalElements: current.totalElements - 1,
          };
        }
      }); 
  },
});

/** TODO:
 * please replace channel => your feature name
 * ex:
 *      my feature is booking 
 *  name sagas like
 *      channelServiceReducer => bookingServiceReducers
 * 
 * // TODO:
 * Move to rootReducer (src/store/root/reducers.ts) and import your feature reducer
 */
export const channelUIActions = Slice.actions;
const channelServiceReducer = Slice.reducer;
export default channelServiceReducer;
